import { PageHero } from "@/components/hero/PageHero";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { usePricingCopy } from "@/lib/pricingContext";
import { faqs } from "@/routes/faqQuestions";

export function FAQ() {
  const { paidPriceLabel } = usePricingCopy();
  const questions = faqs(paidPriceLabel);
  return (
    <div className="flex min-h-screen flex-col bg-bg text-ink">
      <Header />
      <main className="flex-1">
        <PageHero
          eyebrow="FAQ"
          title="Common questions."
          subtitle="Quick answers to what most people ask before starting an appeal."
        />
        <section className="bg-bg py-20">
          <div className="wrap max-w-3xl">
            <dl className="space-y-4">
              {questions.map((qa) => (
                <div
                  key={qa.q}
                  className="rounded-xl border border-border bg-surface p-6 transition hover:border-primary/30"
                >
                  <dt className="font-heading text-lg font-bold tracking-tight text-ink">{qa.q}</dt>
                  <dd className="mt-2 text-sm leading-relaxed text-muted">{qa.a}</dd>
                </div>
              ))}
            </dl>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
